import classNames from 'classnames';
import Page from '../../components/Layout/Page';
import { getPageContent } from '../../api/pagesApi';
import { getReport, ReportType } from '../../api/reportApi';
import { genShareConfig } from '../../components/Share/use-config-share';
import { serverSideTranslation } from '../../util/next';
import NewsGroup from '../../components/NewsGroup';
import ReportCard from '../../components/ReportCard';
import styles from './RiderProtection.module.scss';

const homeMoImg = 'https://p0.meituan.net/smartvenus/75ecebd8509d7e41af84d2c54d49cd2f3283477.jpg@2000w|0_30_1270_0a';
const smallHomeMoImg =
  'https://p0.meituan.net/smartvenus/75ecebd8509d7e41af84d2c54d49cd2f3283477.jpg@1024w|0_80_500_0a';

const RiderProtection = (props: any) => {
  const { _nextI18Next: i18n, pageContentData, reportList } = props;
  const { shareContent = {}, pageContent = {} } = pageContentData || {};
  const description =
    shareContent.shareDetail ||
    '我们正持续关注骑手保障，不断优化骑手体验。始终坚持公开透明原则，推动用户、骑手与平台共赢。';
  const title = shareContent.shareTitle || '骑手保障';
  const { pageTitle, pageDesc, groupDataList, reportTitle } = pageContent;

  return (
    <Page description={description} title={title}>
      <div className="w-full bg-[#f7f8f9]">
        <section
          className={classNames(
            styles['header-bg-image'],
            'mt-15 xl:mt-20',
            'bg-cover bg-center bg-no-repeat',
            'overflow-hidden',
          )}
          style={
            {
              '--bg-image': `url(${smallHomeMoImg})`,
              '--1024-bg': `url(${homeMoImg})`,
            } as any
          }
        >
          <div className={classNames(styles['header-bg'])}>
            <h1 className="mt-font mx-auto w-[303px] pt-[64px] text-center text-[26px] font-normal leading-[44px] text-[#fff] md:w-[908px] md:pt-[70px] md:text-[52px] md:leading-[72px]">
              {pageTitle}
            </h1>
            <h3 className="mt-font mx-auto w-[327px] pb-[68px] pt-[8px] text-center text-[20px] font-normal leading-[28px] text-[#fff] md:w-[908px] md:pb-[80px] md:pt-[10px] md:text-[32px] md:leading-[44px]">
              {pageDesc}
            </h3>
          </div>
        </section>
        {groupDataList?.map((item: any, index: number) => {
          return <NewsGroup key={index} lanType={i18n.initialLocale} {...item} />;
        })}
        <div className="bg-cover bg-center bg-no-repeat pb-[40px] md:pb-[100px]">
          <div className="m-auto max-w-screen-xl px-5 xl:px-0">
            {/* 媒体资源标题 */}
            <p className="mb-5 mt-7 text-lg font-medium leading-5 text-black lg:mb-6 lg:mt-10 lg:text-2sm lg:leading-10">
              {reportTitle}
            </p>
            <div className="grid h-auto grid-cols-2 gap-4  sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 lg:gap-8 ">
              {reportList?.map((item: any, index: any) => {
                return <ReportCard reportCardData={item} key={index} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/newsroom/rider-protection',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  const reportList = await getReport({ lanType: locale, reportType: ReportType.RIDER_PROTECTION });
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_i8l0gkjp',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      reportList,
      ...genShareConfig(pageContentData),
      ...(await serverSideTranslation(locale, ['contactus', 'cookie', 'common'])),
    },
  };
}

export default RiderProtection;
